const API_URL = process.env.REACT_APP_API_URL;

let apiUrls = {
    elements: `${API_URL}/inserting-elements`,
    saveDiscountTable: `${API_URL}/inserting-element/save-discount-table`
};

export default apiUrls;
